import { render, staticRenderFns } from "./RelatorioCustoDadosModal.vue?vue&type=template&id=c96d7a48&scoped=true&"
import script from "./RelatorioCustoDadosModal.vue?vue&type=script&lang=js&"
export * from "./RelatorioCustoDadosModal.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioCustoDadosModal.vue?vue&type=style&index=0&id=c96d7a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d7a48",
  null
  
)

export default component.exports